import React from "react";
import { SRLWrapper } from "simple-react-lightbox";
import './styles.css'
import axios from 'axios';
import MetaTags from 'react-meta-tags';

export default class Gallery extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            gallery:[],
            category: ''
        }
    }
    componentDidMount() {
        this.getGallery()
    }
    UNSAFE_componentWillReceiveProps() {
        this.getGallery()
    }

    getGallery = () => {
        let data;
        axios.get(`/zdrojeJSON.json`)
            .then(res => {
            const gallery = res.data;
            for(let i = 0; i<gallery.length; i++) {
                if(gallery[i].category === this.props.gallery) {
                    data = gallery[i].gallery
                    this.setState({ gallery: data }, () => {
                        this.forceUpdate();
                    });
                    return;
                }
                }
            }
        )
    }

        render() {

    return (
        <SRLWrapper>
            <main id="page-wrap">
                <MetaTags>
                    <title>Miroslav Babinčák</title>
                    <meta name="description" content="Umelecká a reklamná tvorba - 3D nápisy, maľovaná reklama, obrazy, kreslené portréty, airbrush, tetovania, foto a ďalšie..." />
                    <meta property="og:title" content="Miroslav Babinčák" />
                    <meta name="keywords" content="reklama, babincak, 3d reklama, malovana reklama, portrety, michalovce"/>
                </MetaTags>
                <h1 className="gallery-header">{this.props.header}</h1>
                <div className="gallery">
                    {
                    this.state.gallery.map((image, key) => {
                        return(
                        <a href={image.zdroj} key={key}>
                            <img src={image.zdroj} alt={image.popis} />
                        </a>
                        )
                    })}
                </div>
            </main>
        </SRLWrapper>
    );
    }
}